export const CACHE_KEY_LIST_PREPAID = 'prepaid';
export const CACHE_KEY_PREPAID = 'prepaid-one';
export const ROUTE_PATH_PREPAID = '/payments/prepaid';
export const TRANSLATION_PREFIX_PREPAID = 'prepaid';
export const SECURITY_KEY_PREPAID = 'PREPAID';

export const PAYMENT_GATEWAY = {
  TRANSFERMOVIL_GATEWAY_TYPE: 'Transfermóvil',
  ENZONA_GATEWAY_TYPE: 'EnZona',
};
